<template>
  <div class="image-preview">
    <div class="img-wrap">
      <div class="mask">
        <div class="plus-icon" v-if="src">
          <el-icon @click.stop="handlePreview" style="margin-right: 4px;">
            <ZoomIn />
          </el-icon>
        </div>
      </div>
      <el-image
        v-if="src"
        :src="src"
        style="width: 60px;height:60px; border-radius: 2px;"
        fit="fill"
      />
    </div>
    <el-dialog
      class="global-dialog"
      top="40vh"
      width="70%"
      draggable
      destroy-on-close
      :close-on-click-modal="false"
      v-model="dialogVisible"
    >
      <el-image
        style="width: 100%; height: 100%; border-radius: 2px;"
        :src="src"
        fit="fit"
      />
    </el-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { ZoomIn } from '@element-plus/icons-vue';

const props = defineProps({
  src: {
    type: String,
    required: true, // 图片地址
  },
});

const dialogVisible = ref(false);

const handlePreview = () => {
  dialogVisible.value = true;
};
</script>

<style lang="scss" scoped>
.image-preview {
  display: flex;
  align-items: center;
}
.img-wrap {
  width: 60px;
  position: relative;
  &:hover {
    .mask {
      width: 100%;
      height: 60px;
      color: #FFFFFF;
      background: rgba(0,0,0,0.2);
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      .plus-icon {
        display: flex;
      }
    }
  }
}
.plus-icon {
  cursor: pointer;
  display: none;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  z-index: 1;
}
</style>